import React, { useEffect } from "react";

function AjudaModal({ id, titol, lead, children, onTancar }) {
  useEffect(() => {
    const tancar = (event) => {
      if (event.key !== "Escape") return;
      event.stopImmediatePropagation();
      onTancar();
    };
    window.addEventListener("keydown", tancar, true);
    return () => window.removeEventListener("keydown", tancar, true);
  }, [onTancar]);

  return (
    <div
      className="dv2-modalOverlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby={id}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onTancar();
      }}
    >
      <div className="dv2-modal dv2-modal--wide">
        <div className="dv2-modal-head">
          <h3 id={id} className="dv2-modal-title">
            {titol}
          </h3>
          <button
            type="button"
            className="dv2-btn dv2-btn--icon dv2-btn--ghost"
            title="Tancar"
            aria-label="Tancar"
            onClick={onTancar}
          >
            ✕
          </button>
        </div>
        {lead && <p className="dv2-modal-lead">{lead}</p>}
        <div className="dv2-help">{children}</div>
        <div className="dv2-modal-actions">
          <button type="button" className="dv2-btn dv2-btn--primary" onClick={onTancar}>
            Tancar
          </button>
        </div>
      </div>
    </div>
  );
}

export function BotoAjuda({ title = "Ajuda", onClick }) {
  return (
    <button
      type="button"
      className="dv2-btn dv2-btn--icon dv2-btn--ghost"
      title={title}
      aria-label="Ajuda"
      onClick={onClick}
    >
      ?
    </button>
  );
}

export default AjudaModal;
